import styled, { css } from 'styled-components';
import { common, fonts } from 'themes/default';

const statusMap = new Map([
  ['available', ''],
  ['assigned', 'assigned'],
  ['selected', 'selected'],
  ['unavailable', 'unavailable'],
  ['nonEditable', 'non-editable'],
  ['blocked', 'blocked']
]);

const getColour = (service = 'es', seatType, colourType) => common.seatmaps?.[service]?.[seatType]?.[colourType];

const getSeatVariants = (service) =>
  [...statusMap]
    .map(([seatType, status]) => {
      const attributeSelector = status ? `[data-status="${status}"]` : '';
      return `/* Background */
  .c-seat${attributeSelector} .c-seat__background {
    color: ${getColour(service, seatType, 'backgroundColour') || 'transparent'};
    stroke: ${getColour(service, seatType, 'strokeColour') || 'transparent'};
  }
  
  .c-seat${attributeSelector}:hover .c-seat__background {
    color: ${getColour(service, seatType, 'hoverBackgroundColour') || getColour(service, seatType, 'backgroundColour') || 'transparent'};
  }
  
  /* Seat strikethrough */
  .c-seat${attributeSelector} .c-seat__line {
    color: ${getColour(service, seatType, 'lineColour') || 'transparent'};
    display: block;
  }
  
  .c-seat${attributeSelector}:hover .c-seat__line {
    color: ${getColour(service, seatType, 'hoverLineColour') || getColour(service, seatType, 'lineColour') || 'transparent'};
  }
  
  /* Seat icon */
  .c-seat${attributeSelector} .c-seat__seat-element {
    color: ${getColour(service, seatType, 'iconColour') || 'transparent'};
  }
  
  .c-seat${attributeSelector}:hover .c-seat__seat-element {
    color: ${getColour(service, seatType, 'hoverIconColour') || getColour(service, seatType, 'iconColour') || 'transparent'};
  }
  
  /* Seat number */
  .c-seat${attributeSelector} .c-seat__text {
    color: ${getColour(service, seatType, 'fontColour') || 'transparent'};
    font-family: ${fonts.fontFamily};
  }
  
  .c-seat${attributeSelector}:hover .c-seat__text {
    color: ${getColour(service, seatType, 'hoverFontColour') || getColour(service, seatType, 'fontColour') || 'transparent'};
    font-family: ${fonts.fontFamily};
  }`;
    })
    .join('\n');

const getSeatStyles = (service) => css`
  .c-seat__line {
    color: transparent;
  }

  .c-seat__background {
    color: transparent;
    stroke: transparent;
    stroke-width: 2px;
  }

  ${getSeatVariants(service)}
`;

export const svgStyle = getSeatStyles('es');
export const svgStyleER = getSeatStyles('er');

export const SvgStyle = styled.svg`
  ${(props) => (props.isErSeat ? getSeatStyles('er') : getSeatStyles('es'))}
`;
